'use client'

import { cardDrawStore } from '@/store/card-draw.store'
import { dialogStore } from '@/store/ui/dialog.store'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React, { PropsWithChildren, Suspense, useEffect } from 'react'
import { useArtistRouter } from '@/hooks/useArtistRouter'
import { usePathname } from 'next/navigation'
import { DrawMotion } from './draw-motion/DrawMotion'
import { sidebarStore } from '@/store/ui/sidebar.store'
import ToastViewport from '@/components/ui/Toast'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
})

export const Root = ({ children }: PropsWithChildren) => {
  const { visible: dialogVisible, dialogComponent } = dialogStore()
  const { changeVisible: changeSidebarVisible } = sidebarStore()
  const { changeDrawArtistType } = cardDrawStore()
  const { saveLastPageArtistFirstPathname, getLastPageArtistFirstPathname } = useArtistRouter()
  const pathname = usePathname()

  useEffect(() => {
    saveLastPageArtistFirstPathname()
    changeDrawArtistType({ drawArtistType: getLastPageArtistFirstPathname() })
    changeSidebarVisible({ visible: false })
  }, [pathname])

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense>
        {children}
        {dialogVisible && dialogComponent}
        <ToastViewport />
        <DrawMotion />
      </Suspense>
    </QueryClientProvider>
  )
}
